import React, { useState, useEffect } from 'react';
import styles from 'feature/settings/index.module.sass';
import { useHistory } from 'react-router-dom';
import CardItemGroup from 'components/card-item-group';
import iconProfile from 'assets/icon_profile.svg';
import iconPolicy from 'assets/icon_policy.svg';
import iconLogout from 'assets/icon_logout.svg';
import { useAppContext, SHOW_TOAST_MESSAGE, RESET } from 'use-app';
import { termsUrl } from 'config';
import ButtonDialog from 'components/button-dialog';
import repo from 'service/repository';
import { clearAuth, clearSkipLogin } from 'service/local-data-provider';
import LoadingDialog from 'components/loading-dialog';
import { getLoginState } from 'model/user';
import { PATH } from 'config';
import amplitude from 'service/amplitude';
import PowerBy from 'components/power-by';
import { openLink } from 'helpers/link-helper';
import { isLineBank } from 'config';
import { isIknow99 } from 'config';
import { isNpcpay } from 'config';

const Settings = () => {
  const { dispatch } = useAppContext();
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [logoutDialog, setLogoutDialog] = useState(false);
  const history = useHistory();
  const loginState = getLoginState();

  useEffect(() => {
    amplitude.setting_pageview();
  }, []);

  const logout = () => {
    setLogoutLoading(true);
    repo.logout().then(() => {
      dispatch({ type: RESET });

      clearAuth();
      clearSkipLogin();
      history.push(PATH.USER_WELCOME);
    });
  };

  const linkToLogin = () => {
    dispatch({
      type: SHOW_TOAST_MESSAGE,
      payload: '請先登入再繼續',
    });
    history.push(PATH.USER_LOGIN);
  };

  const memberItems = [
    {
      id: 'profile-setting',
      icon: iconProfile,
      content: '個人資料',
      withArrow: true,
      onClick: () => {
        amplitude.setting_profile_onClick();
        if (loginState === 'user') {
          history.push(PATH.PROFILE_SETTING);
        } else {
          linkToLogin();
        }
      },
    },
    {
      id: 'terms',
      icon: iconPolicy,
      content: '服務條款',
      withArrow: true,
      onClick: () => {
        amplitude.setting_terms_onClick();
        openLink(termsUrl);
      },
    },
    {
      id: 'logout',
      icon: iconLogout,
      content: '登出',
      onClick: () => {
        amplitude.setting_logout_onClick();
        setLogoutDialog(true);
      },
    },
  ];

  const settingsList = () => {
    if (loginState !== 'user' || isLineBank || isIknow99 || isNpcpay) {
      return memberItems.filter(item => item.id !== 'logout');
    }

    return memberItems;
  };

  return (
    <div className={styles.settings}>
      <LoadingDialog isShow={logoutLoading} />
      <ButtonDialog
        isShow={logoutDialog}
        title="是否確認登出帳號？"
        horizonal
        items={[
          {
            content: '帳號登出',
            theme: 'negative',
            onClick: logout,
          },
          {
            content: '取消',
            theme: 'cancel',
            onClick: () => setLogoutDialog(false),
          },
        ]}
      />
      <section>
        <div className={styles.title}>會員設定</div>
        <CardItemGroup data={settingsList()} />
      </section>
      <div className={styles.footer}>
        <PowerBy />
      </div>
    </div>
  );
};

export default Settings;
